import $ from 'jquery';
import { throttle } from 'throttle-debounce';

import { $Elements, Classes, Events, Durations } from './constants';
import { disableBodyScroll, enableBodyScroll, smoothScrollTo } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	// Handle submenu image hover
	$Elements.PageWrapper.on('mouseenter touchstart', '.main-menu > li > .sub-menu-wrapper .sub-menu .menu-item', throttle(Durations.default.ms, function() {
		const $menuItem = $(this);
		const $subMenuWrapper = $menuItem.closest('.sub-menu-wrapper');
		const $subMenuImage = $subMenuWrapper.find('.sub-menu-image');
		const $childImages = $subMenuImage.find('.child-image');
		const itemIndex = $menuItem.index();

		// Remove active class from all child images and add it to the current one
		$childImages.removeClass(Classes.active);
		$subMenuImage.find(`.child-image.key-${itemIndex}`).addClass(Classes.active);
	}));

	$Elements.PageWrapper.on(Events.click, '.menu-toggle, a[href="#menu-wrapper"], .menu-overlay', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
		}
		else {
			$Elements.body.addClass(Classes.menuOpen);
			disableBodyScroll();
		}
	});

	$Elements.PageWrapper.on(Events.click, '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});
});

$Elements.document.on(Events.page.loaded, () => {

	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}
});
